import React from 'react';
export function SecureCss({ css, containerProps, type }) {
    const cleanCss = css.replace(/</g, '&lt;');
    return (React.createElement("style", { ...(type === undefined
            ? { type: 'text/css' }
            : type === null
                ? {}
                : { type }), ...containerProps, dangerouslySetInnerHTML: { __html: cleanCss } }));
}
//# sourceMappingURL=SecureCss.js.map